<template>
  <header :class="[$style['title'], title.length > 22 && $style['title--long']]" :style="{ '--fit': fit }">
    <h1 :class="$style['title__text']">{{ title }}</h1>
    <div v-if="$slots.default" :class="$style['title__lead']">
      <slot />
    </div>
  </header>
</template>
<script setup lang="ts">
// The page title for pages without a photo: giant capitals, sized so the longest word fits the width
const props = defineProps<{ title: string }>()
const fit = computed(() => Math.max(6, ...props.title.split(/\s+/).map(word => word.length)))
</script>
<style module>
.title {
  --title-max: var(--stage-title);

  margin-bottom: clamp(2.5rem, 1.5rem + 3vw, 5rem);
  container-type: inline-size;
}

.title--long {
  --title-max: var(--stage-title-long);
}

.title__text {
  margin: 0;
  font-size: min(var(--title-max), 100cqi / (var(--fit) * 0.72));
}

.title__lead {
  max-width: var(--stage-measure);
  margin-top: var(--spacing-xl);
  font-size: clamp(1.125rem, 1rem + 0.5vw, 1.5rem);
  line-height: 1.45;
  color: var(--stage-soft);
}

.title__lead :where(p) {
  margin: 0 0 0.75em;
  font-size: inherit;
}
</style>
